<script setup lang="ts">
withDefaults(
  defineProps<{
    headCount?: number;
    rowCount?: number;
    hasTitle?: boolean;
  }>(),
  {
    headCount: 5,
    rowCount: 5,
    hasTitle: false,
  }
);
</script>

<template>
  <ui-skeleton v-if="hasTitle" width="300px" height="24px" />
  <q-markup-table separator="none" flat>
    <thead>
      <tr>
        <th v-for="n in headCount" :key="n" class="text-left">
          <ui-skeleton height="12px" />
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="n in rowCount" :key="n">
        <td v-for="a in headCount" :key="a" class="text-left">
          <ui-skeleton height="12px" width="85px" />
        </td>
      </tr>
    </tbody>
  </q-markup-table>
</template>
